// แถบอัปโหลดของเมนู Finance — เลือกหมวดกับแคมเปญก่อน แล้วค่อยเลือกไฟล์
//
// ต่างจากเมนู Documents ตรงที่ที่นั่นแบ่งกล่องอัปโหลดตามแคมเปญอยู่แล้ว แคมเปญจึงมาจากกล่อง
// ที่กด ส่วนที่นี่เป็นรายการเดียวรวมทุกแคมเปญ ค่าสองอันนี้จึงต้องถามก่อนอัปโหลด
// (ทั้งคู่แก้ทีหลังได้ที่แถวของไฟล์ — แคมเปญไม่ระบุก็ปล่อยว่างไว้ได้)
import { useState } from "react";
import type { Campaign } from "@contracts/api";
import type { FinanceCategory } from "@features/documents/api/documents-api";
import { MAX_UPLOAD_MB, UploadBox } from "@features/documents/components/upload-box";
import { FINANCE_CATEGORIES, DEFAULT_CATEGORY } from "../lib/categories";

export function FinanceUpload({
  campaigns,
  uploading,
  onFiles,
}: {
  campaigns: Campaign[];
  uploading: boolean;
  onFiles: (files: File[], category: FinanceCategory, campaignId: string) => Promise<string[]>;
}) {
  const [category, setCategory] = useState<FinanceCategory>(DEFAULT_CATEGORY);
  const [campaignId, setCampaignId] = useState("");

  return (
    <div className="panel fin-upload">
      <div className="fin-upload-row">
        <label className="fin-field">
          <span className="muted small-note">หมวดเอกสาร</span>
          <select value={category} onChange={(e) => setCategory(e.target.value as FinanceCategory)}>
            {FINANCE_CATEGORIES.map((c) => (
              <option key={c.key} value={c.key}>
                {c.label}
              </option>
            ))}
          </select>
        </label>
        <label className="fin-field">
          <span className="muted small-note">แคมเปญ</span>
          <select value={campaignId} onChange={(e) => setCampaignId(e.target.value)}>
            <option value="">— ยังไม่ระบุ (เลือกทีหลังได้) —</option>
            {campaigns.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <UploadBox
        disabled={uploading}
        hint={
          uploading
            ? "กำลังอัปโหลด…"
            : `Excel · PDF · รูปภาพ · PowerPoint · Word — ไฟล์ละไม่เกิน ${MAX_UPLOAD_MB}MB`
        }
        onFiles={(files) => onFiles(files, category, campaignId)}
      />
    </div>
  );
}
